import React, { useState } from 'react';
import './MobileApp.scss';
import ImgLormnHeader from './img/lMN-logo-white.png';
import ImgLormnFooter from './img/LMN-logo-Footer1.png';
import MobileHeroImage from './img/Hero-Image-Mobile.png';

export default function MobileApp() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const solutions = [
        'Robust audience targeting',
        'Premium native display',
        'Sponsored product ads',
        'Audience extension with programmatic activation',
        'Social media partnerships',
        'Closed-loop measurement and insights'
    ];

    const stats = [
        { value: '$83B', label: 'in sales in 2025' },
        { value: '1,750+', label: 'home improvement stores across U.S.' },
        { value: '39M+', label: 'average weekly visits on Lowe\'s digital platforms' },
        { value: '65% / 35%', label: 'DIY and PRO shopper split' }
    ];

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
        e.preventDefault();
        setIsMenuOpen(false);
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="mobile">
            {/* Header Section */}
            <header className="header">
                <nav className="header__nav">
                    <img src={ImgLormnHeader} alt="Lowe's Media Network" className="header__logo" />
                    <button className="header__menu-btn" aria-label="Menu" onClick={toggleMenu}>
                        <svg width="24" height="24" viewBox="0 0 24 24">
                            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" fill="white"/>
                        </svg>
                    </button>
                </nav>
                {isMenuOpen && (
                    <nav className="header__menu">
                        <a href="#benefits" className="header__menu-item" onClick={(e) => handleNavClick(e, 'benefits')}>About us</a>
                        <div className="header__menu-divider"></div>
                        <a href="#solutions" className="header__menu-item" onClick={(e) => handleNavClick(e, 'solutions')}>Solutions</a>
                        <div className="header__menu-divider"></div>
                        <a href="mailto:lowesmedianetwork@lowes.com" className="header__menu-item" onClick={toggleMenu}>Contact us</a>
                    </nav>
                )}
                <div className="header__content">
                    <h1 className="header__title">
                        Your Home<br/>
                        to Growth.
                    </h1>
                    <p className="header__subtitle">
                        Deliver meaningful impact<br/>
                        beyond the last click.
                    </p>
                </div>
                <div className="hero__image-container">
                    <img
                        src={MobileHeroImage}
                        alt="Lowe's associate helping customer"
                        className="hero__image"
                    />
                </div>
            </header>

            {/* Main Content */}
            <main className="main">
                {/* Benefits Section */}
                <section id="benefits" className="benefits">
                    <h2 className="benefits__title">
                        Real-time data. Omnichannel reach. Proven results.
                    </h2>
                    <p className="benefits__description">
                        One of the fastest-growing retail media networks, Lowe&apos;s Media Network combines proprietary customer insights with customizable omnichannel advertising solutions. We enable brands to connect with shoppers at every stage of the home improvement journey; driving awareness, consideration and measurable performance.
                    </p>
                </section>

                {/* Audience Section */}
                <section className="audience">
                    <div className="audience__stat">
                        <span className="audience__stat-value">39M+</span>
                        <span className="audience__stat-label">
                            average weekly visits on<br/>
                            Lowe&apos;s digital platforms
                        </span>
                    </div>
                    <div className="audience__content">
                        <h2 className="audience__title">
                            Get unparalleled<br/> access to 120M+<br/> unique customers
                        </h2>
                        <p className="audience__description">
                            Both DIY and Pro customers turn to<br/>Lowe&apos;s for more than just shopping.<br/> They come for inspiration, for the right<br/> services and for experiences that <br/>ultimately move products from aisles to <br/>carts. With US shoppers spending more<br/> time at home, they are making sure<br/> homes not only provide shelter, but also<br/> enhance their lives.
                            <br/><br/>
                            Lowe&apos;s Media Network leverages rich first <br/>and third–party data to help brands meet<br/> a wide range of marketing objectives with<br/> over 120M Lowe&apos;s customers, from<br/> share–of–shelf and new product launches<br/> to seasonal promotions.
                        </p>
                    </div>
                </section>

                {/* Solutions Section */}
                <section id="solutions" className="solutions">
                    <div className="solutions__content">
                        <h2 className="solutions__title">
                            Solutions tailored<br/>
                            to your business <br/>ambitions.
                        </h2>
                        <p className="solutions__description">
                            Lowe&apos;s Media Network offers brands a <br/>consultative approach and a robust<br/> omnichannel suite of products and solutions.<br/> With an evolving product repository, rich<br/> campaign performance insights, and flexible<br/> creative strategies, there is a portfolio of<br/> solutions for every brand&apos;s goals.
                        </p>
                    </div>
                    <div className="solutions__list">
                        {solutions.map((solution, index) => (
                            <div key={index} className="solutions__item">
                                {solution}
                            </div>
                        ))}
                    </div>
                </section>

                {/* Company Info Section */}
                <section className="company-info">
                    <div className="company-info__content">
                        <p className="company-info__text">
                            Lowe&apos;s is a best-in-class home improvement retailer. We solve problems and fulfill dreams for the home. Lowe&apos;s Media Network supports brand partners in reaching our customers throughout their shopping journey, in store and online.
                        </p>
                    </div>
                </section>

                {/* Stats Section */}
                <section className="stats">
                    <div className="stats__row">
                        {stats.slice(0, 2).map((stat, index) => (
                            <div key={index} className="stats__item">
                                <span className="stats__value">{stat.value}</span>
                                <span className="stats__label">{stat.label}</span>
                            </div>
                        ))}
                    </div>
                    <div className="stats__row">
                        {stats.slice(2, 4).map((stat, index) => (
                            <div key={index} className="stats__item">
                                <span className="stats__value">{stat.value}</span>
                                <span className="stats__label">{stat.label}</span>
                            </div>
                        ))}
                    </div>
                </section>

                {/* CTA Section */}

                    <section className="cta">
                        <div className="cta__content">
                            <h2 className="cta__title">Welcome to<br/>Lowe&apos;s Media Network</h2>
                            <p className="cta__subtitle">Get in touch to see how, together, we can<br/>move the needle for your brand.</p>
                        </div>
                        <a href="mailto:lowesmedianetwork@lowes.com" className="cta__email">lowesmedianetwork@lowes.com</a>
                    </section>
            </main>

            {/* Footer */}
            <footer className="footer">
                <div className="footer__brand">
                    <img src={ImgLormnFooter} alt="Lowe's Media Network" className="footer__logo" />
                    <span className="footer__tagline">We Help. Brands Grow.</span>
                </div>

                <div className="footer__links-section">
                    <h3 className="footer__links-title">Privacy &amp; Use</h3>
                    <div className="footer__links-grid">
                        <div className="footer__links-column">
                            <a href="https://www.lowes.com/l/terms-and-conditions-of-use.html" className="footer__link">Terms</a>
                            <a href="https://www.lowes.com/l/privacy-and-security-statement.html" className="footer__link">Privacy Statement</a>
                            <a href="https://www.lowes.com/l/privacy-and-security-statement.html#interestadvertising" className="footer__link">Interest-Based Ads</a>
                        </div>
                        <div className="footer__links-column">
                            <a href="https://www.lowes.com/l/privacy-and-security-statement.html#addnoticecaliforniacustomer" className="footer__link">CA Privacy Rights</a>
                            <a href="https://www.lowes.com/l/privacy-and-security-statement.html#MoreAboutSale" className="footer__link">Do Not Sell My</a>
                            <a href="https://www.lowes.com/l/privacy-and-security-statement.html#MoreAboutSale" className="footer__link">Personal Information</a>
                        </div>
                    </div>
                </div>
                <div className="footer__bottom">
                    <div className="footer__contact">
                        <span className="footer__contact-text">Got questions?</span>
                        <a href="mailto:lowesmedianetwork@lowes.com" className="footer__contact-btn">Contact Us</a>
                    </div>

                <div className="footer__external-links">
                        <a href="https://www.lowes.com/" className="footer__link">Lowes.com</a>
                        <a href="https://corporate.lowes.com/investors" className="footer__link">Investor Site</a>
                    </div>
                </div>
            </footer>
        </div>
    );
}
